module.exports = __webpack_public_path__ + "static/media/Image_4.f59e1c87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureBlock/images/Image_4.jpg
// module id = 849
// module chunks = 0